import { render, staticRenderFns } from "./CanceledWaiterListTab.vue?vue&type=template&id=e756068e&scoped=true&lang=pug"
import script from "./CanceledWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./CanceledWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./CanceledWaiterListTab.vue?vue&type=style&index=0&id=e756068e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e756068e",
  null
  
)

export default component.exports